export function UsFlag() {
  return (
    <svg viewBox="0 0 640 480" preserveAspectRatio="xMidYMid slice">
      <path fill="#bd3d44" d="M0 0h640v480H0" />
      <path
        stroke="#fff"
        strokeWidth="37"
        d="M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"
      />
      <path fill="#192f5d" d="M0 0h364.8v258.5H0" />
      <marker id="us-a" markerHeight="30" markerWidth="30">
        <path fill="#fff" d="m14 0 9 27L0 10h28L5 27z" />
      </marker>
      <path
        fill="none"
        markerMid="url(#us-a)"
        d="m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60z"
      />
    </svg>
  );
}

export function BrFlag() {
  return (
    <svg viewBox="0 0 640 480" preserveAspectRatio="xMidYMid slice">
      <path fill="#229e45" fillRule="evenodd" d="M0 0h640v480H0z" />
      <path
        fill="#f8e509"
        fillRule="evenodd"
        d="m321.4 436 301.5-195.7L319.6 44 17.1 240.7z"
      />
      <path
        fill="#2b49a3"
        fillRule="evenodd"
        d="M452.8 240c0 70.3-57.1 127.3-127.6 127.3A127.4 127.4 0 1 1 452.8 240"
      />
    </svg>
  );
}

export function EsFlag() {
  return (
    <svg viewBox="0 0 640 480" preserveAspectRatio="xMidYMid slice">
      <path fill="#c60b1e" d="M0 0h640v480H0z" />
      <path fill="#ffc400" d="M0 120h640v240H0z" />
    </svg>
  );
}

export function MxFlag() {
  return (
    <svg viewBox="0 0 640 480" preserveAspectRatio="xMidYMid slice">
      <path fill="#006847" d="M0 0h213.3v480H0z" />
      <path fill="#fff" d="M213.3 0h213.4v480H213.3z" />
      <path fill="#ce1126" d="M426.7 0H640v480H426.7z" />
      <circle cx="320" cy="240" r="55" fill="#a97c50" />
    </svg>
  );
}

export function CoFlag() {
  return (
    <svg viewBox="0 0 640 480" preserveAspectRatio="xMidYMid slice">
      <path fill="#fcd116" d="M0 0h640v240H0z" />
      <path fill="#003893" d="M0 240h640v120H0z" />
      <path fill="#ce1126" d="M0 360h640v120H0z" />
    </svg>
  );
}

// Neutral icon for the generic (Global) English version.
export function GlobalFlag() {
  return (
    <svg viewBox="0 0 640 480" preserveAspectRatio="xMidYMid slice">
      <path fill="#2b5fa8" d="M0 0h640v480H0z" />
      <g fill="none" stroke="#fff" strokeWidth="22">
        <circle cx="320" cy="240" r="170" />
        <ellipse cx="320" cy="240" rx="75" ry="170" />
        <path d="M150 240h340M185 150h270M185 330h270" />
      </g>
    </svg>
  );
}
